import { Component, OnInit, Input } from '@angular/core';
import { BarrelItem } from '../../menu.model';

@Component({
  selector: 'barrel-pick',
  templateUrl: './barrel-pick.component.html',
  styleUrls: ['./barrel-pick.component.scss']
})
export class BarrelPickComponent implements OnInit {

  constructor() {
    console.log('barrel: ', this.barrelItem);
  }

  @Input() barrelItem: Array<BarrelItem> = [];
  @Input() activeSection: string | undefined;

  ngOnInit(): void {
    console.log('barrel: ', this.barrelItem);
  }

}
